import GradientGenerator from './components/GradientGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <GradientGenerator/>
    </div>
  );
}

export default App;
